import { asyncComponentLoader } from './helpers'
import paths from './paths'

export const OTA_ROUTES = [
  {
    path: '/',
    component: asyncComponentLoader('OtaView', 'OtaRouterView'),
    children: [
      {
        path: '',
        name: paths.ota.home,
        component: asyncComponentLoader('OtaView', 'OtaHome')
      },
      {
        path: 'search-hotels',
        name: paths.ota.searchHotels,
        component: asyncComponentLoader('OtaView', 'SearchHotels')
      },
      {
        path: 'hotels/:code',
        component: asyncComponentLoader('OtaView', 'OtaFacilityRouterView'),
        children: [
          {
            path: '',
            name: paths.ota.searchRooms,
            component: asyncComponentLoader('OtaView', 'OtaSearchRooms/index')
          }
        ]
      }
    ]
  },
  {
    path: '/reservation',
    component: asyncComponentLoader('OtaView', 'OtaReservation/index'),
    children: [
      // ...
    ]
  }
]
